<template>

  <div class="login container">
       <div class="row d-flex justify-content-center mb-3">
            <img alt="toggle logo" src="../assets/toggle.svg" id="logo">
        </div>
        <div  class="row d-flex justify-content-center">
            <img style="width:120px;" alt="pos logo" src="../assets/pos_mode_logo.svg" id="pos_mode_logo_logo">
        </div>
        <div class="row">
            <h2 style="color:#6A819A;" class="col-md-12 pt-2 mt-5">Two factor log in</h2>
        </div>
      <!--Before send code-->
      <div  class="col-12 my-4" v-if="!smsSent">
        <p class="mb-4"> To verify this login press below to send a verification code via SMS to {{ userEndingNumber }} </p>
        <cta class="mt-4" type="submit" @click="sendSMS" text="Send Code" :loading="loading"  />
        <p v-show="responseMessage" :class="isError ? 'error' : 'success'" >
          {{responseMessage}}
        </p>
        <p class="m-4"> We're just getting you through security </p>
      </div>
      <!--After sent code-->
      <div class="w-100 d-flex justify-content-center">
        <form v-if="smsSent" class="col-12 my-auto  d-flex justify-content-center align-items-center flex-column"  @submit.prevent="validateCode" >
            <text-input :errorMessage="errors[0]" :allowModelSet="true"  v-model="usercode" placeholder="Enter unique code" name="card_reference" v-validate="'required|min:6|max:6'"  />

            <div class="d-flex justify-content-center align-items-center mt-4">
              <label class="pr-3 pb-0 mb-0">Remember me on this device for 30 days</label>
              <input type="checkbox" v-model="remember_me" name="remember_me">
            </div>

            <cta class="mt-4" type="submit" text="Submit" :loading="loadingAfterSuccess"  />
            <p v-if="firstTime">
              <small>
                Not yet received your verification code?
                <span class="auth-link-text" @click="sendSMS"> Try again </span>
              </small>
            </p>
          <p v-if="isInvalid" class="auth-general-error">
              <small class="is-danger">
              Please check if your code is correct or
              <span class="auth-link-text" @click="restartAll"> restart verification </span>
            </small>
          </p>
          <p v-show="responseMessage" :class="isError ? 'is-danger' : 'success'" >
            {{responseMessage}}
          </p>
        </form>
     
      </div>
  </div>
</template>

<script>


export default {
    name: 'Twofactor',
    inject: ['$validator'],
    head: {
      title: 'Toggle - Two Factor'
    },
    layout: 'auth',
    data () {
      return {
        usercode: '',
        remember_me:false,
        userEndingNumber: '',
        smsSent: false,
        isInvalid: false,
        responseMessage: false,
        isError: false,
        firstTime: true,
        loadingAfterSuccess:false
      }
    },
    beforeMount() {
       this.userEndingNumber = this.$store.getters.getTwofactorMobileNumber;
    },
    methods: {
      /**
       * Sends the SMS to the user mobile number
       * @return {void} continues the journey
       */
      sendSMS() {
        this.$store.dispatch('TWOFACTOR_SENDSMS_REQUEST').then((resp) => {
          if (resp === "success" && this.smsSent === false)
          {
            /**
             * If SMS is successful and it's the first time the user sends the SMS: send to the mobile number and change screen to verify the number
             */
            this.smsSent = true;
            this.responseMessage = false;
          }
          else if (resp === "success" && this.smsSent === true)
          {
            /**
             * If SMS is successful and it's not the first time the user sends the SMS: just write success message on screen
             */
            this.isError = false;
            this.responseMessage = 'Code sent.';
          }
        })
          .catch(() => {
            this.responseMessage  = "We had a problem please try again or restart the process."
            this.isError = true;
          });
      },
  
      /**
       * Validates if the TwoAuth code sent by user is correct.
       * @return {void}
       */
      validateCode() {
        this.$validator.validateAll().then((result) => {
           if(result){
        this.loadingAfterSuccess = true;
        this.firstTime = false;
        this.responseMessage = false;
        this.isInvalid = false;
        const {usercode,remember_me} = this;
        this.$store.dispatch('VALIDATE_TWOFACTOR', {usercode,remember_me}).then((resp) => {
          if (resp === 'success')
          {
            /**
             * If the code sent by user is correct, dispatch a method that will send the user to the CRM APP
             */
            this.isInvalid = false;
            this.isError = false;
            this.responseMessage = "Your code is valid.  We're getting everything ready for you.";
            this.$store.commit('SET_TWOFACTOR_JOURNEY_COMPLETE',true);
            this.$router.push({ name: 'home'},false, () => {}); 
          }
          else
          {
            /**
             * Show an generic error if any setback happens when sending the code but with no success message
             */
            this.isError = true;
            this.responseMessage = "There was a problem with your request. Please try again.";
            this.loadingAfterSuccess = false;
          }
        })
          .catch((error) => {
            this.loadingAfterSuccess = false;
            switch (error) {
              case 422:
              case 401:
                this.isError = true;
                this.isInvalid = true;
                break;
              default:
                this.responseMessage  = "We had a problem please try again."
                this.isError = true;
            }
          })
           }
        })
      },
      /**
       * Restarts the journey of user, removing the token  and sending to login screen
       * @return {void}
       */
      restartAll() {
        this.$store.dispatch('logout')
      },
      /**
       * Defines which screen to show the user before mounting the page, based on the setup status.
       * @if setupStatus is success means the user has come from 'setup two factor' screen and already send the SMS, showing only the option to verify the code.
       * @else saves the mobile number from the store and just let the normal flow of the page.
       */
    },
    computed: {
      loading() {
        /**
         * Computes the TwoFactor getter status to check if the request it's loading or not
         * @return {booelan}
         */
        return this.$store.getters.getTwofactorJourneyStatus === "loading" ? true : false;
      }
    }
  }
  
   
</script>

<style lang="scss" scoped>

    .auth-link-text{
        text-decoration: underline;
        font-size: 14px;
        cursor:pointer;
    }

</style>